import { useCallback, useState } from 'react';
import { fetchDropboxFilesAsLocal } from '../utils/dropboxChooser';
import { validateFilesForUpload } from '../utils/fileValidation';

const useDropboxUploadHandler = ({
  accept,
  onFilesReady,
  useValidation = true
}) => {
  const [fileErrorList, setFileErrorList] = useState([]);

  const handleDropboxSuccess = useCallback(async (files) => {
    try {
      const downloadedFiles = await fetchDropboxFilesAsLocal(files);

      if (!useValidation) {
        if (downloadedFiles.length > 0) {
          await onFilesReady(downloadedFiles);
        }
        return;
      }

      const { validFiles, errorList } = await validateFilesForUpload({
        files: downloadedFiles,
        accept
      });

      if (errorList.length) {
        setFileErrorList(errorList);
      }

      if (validFiles.length > 0) {
        await onFilesReady(validFiles);
      }
    } catch (error) {
      console.error('Error importing Dropbox files:', error);
    }
  }, [accept, onFilesReady, useValidation]);

  return {
    handleDropboxSuccess,
    fileErrorList,
    setFileErrorList
  };
};

export default useDropboxUploadHandler;
